import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { fmtDate } from "./News";

export default function NewsDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/news/${id}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [id]);

  if (missing)
    return (
      <div className="pt-40 pb-24 text-center" data-testid="news-missing">
        <p className="text-slate-400">Story not found.</p>
        <Link to="/news" className="text-gold-300 text-sm mt-4 inline-block">Back to news</Link>
      </div>
    );
  if (!post) return <div className="pt-40 pb-24 text-center text-slate-500">Loading…</div>;

  return (
    <div className="pt-28 pb-24" data-testid="news-detail-page">
      <article className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Link
            to="/news"
            data-testid="back-to-news"
            className="inline-flex items-center gap-2 text-sm text-gold-300 hover:text-gold-200 transition-colors mb-8"
          >
            <ArrowLeft size={15} /> All stories
          </Link>
          <p className="text-[11px] tracking-[0.25em] uppercase text-gold-400/80">{fmtDate(post.date)}</p>
          <h1 className="font-serif text-3xl sm:text-5xl text-slate-50 mt-3 leading-tight">{post.title}</h1>
          {post.cover_url && (
            <img
              src={mediaUrl(post.cover_url)}
              alt={post.title}
              className="w-full h-auto rounded-2xl border border-gold-400/20 mt-10"
            />
          )}
          <div className="mt-10 text-slate-300/90 font-light leading-8 whitespace-pre-line" data-testid="news-body">
            {post.body}
          </div>
        </Reveal>
      </article>
    </div>
  );
}
